import { StringParam } from "use-query-params";

export enum FiltersType {
  COMPOSER = "composer",
  TAGS = "tags",
  LENGTH = "length",
  BPM = "bpm",
  IS_ALBUMS_TAB = "isAlbumsTab",
  SORT = "sort",
  PAGE_NUMBER = "pageNumber",
  IS_FILTERS_OPEN = "isFiltersOpen",
  QUICK_FILTERS_CATEGORY = "quickFiltersCategory",
}

export enum AdditionalQueryParams {
  JUMP = "jump",
}

export const queryConfig = {
  [FiltersType.IS_ALBUMS_TAB]: StringParam,
  [FiltersType.SORT]: StringParam,
  [FiltersType.PAGE_NUMBER]: StringParam,
  [FiltersType.IS_FILTERS_OPEN]: StringParam,
  [AdditionalQueryParams.JUMP]: StringParam,
  [FiltersType.QUICK_FILTERS_CATEGORY]: StringParam,
};
